import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.trim";
export default function extractSupportQuery(ruleSet) {
  return ruleSet.split('{')[0].slice(9).trim();
}